/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import {
  Snackbar, Tab, Tabs,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Alert from '@material-ui/lab/Alert';
import UpcomingWebinaire from './UpcomingWebinaire';
import OldWebinaire from './OldWebinaire';
import uiActions from '../../redux/actions/uiActions';
import RegisteredWebinaire from './RegisteredWebinaire';

function a11yProps(index) {
  return {
    id: `webinaire-tab-${index}`,
    'aria-controls': `webinaire-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    minHeight: '85vh',
    width: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(2),
    boxSizing: 'border-box',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'stretch',
    },
  },
  tabs: {
    flexShrink: 0,
    [theme.breakpoints.up('md')]: {
      minWidth: 200,
      paddingTop: theme.spacing(1),
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  tabPanelsWrap: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  tabPanelInner: {
    padding: theme.spacing(2, 2, 3),
    width: '100%',
    boxSizing: 'border-box',
  },
}));

function TabPanel({
  children, value, index, className, ...other
}) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`webinaire-tabpanel-${index}`}
      aria-labelledby={`webinaire-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div className={className}>{children}</div>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  className: PropTypes.string,
};

const Webinaire = ({ userData, changePageTitle }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [value, setValue] = useState(0);
  const [errorSnackBar, setErrorSnackBar] = useState(null);
  const [successSnackBar, setSuccessSnackBar] = useState(null);

  useEffect(() => {
    changePageTitle('Webinaires');
  }, [changePageTitle]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Snackbar role="alert" open={errorSnackBar !== null} onClose={() => { setErrorSnackBar(null); }} anchorOrigin={{ vertical: 'top', horizontal: 'left' }}>
        <Alert role="alert" severity={errorSnackBar !== null ? errorSnackBar.severity : 'error'} variant="filled" onClose={() => { setErrorSnackBar(null); }}>
          {`Error ${errorSnackBar?.code}: ${errorSnackBar?.message}`}
        </Alert>
      </Snackbar>
      <Snackbar role="alert" open={successSnackBar !== null} onClose={() => { setSuccessSnackBar(null); }} anchorOrigin={{ vertical: 'top', horizontal: 'left' }}>
        <Alert role="alert" severity={successSnackBar !== null ? successSnackBar.severity : 'success'} variant="filled" onClose={() => { setSuccessSnackBar(null); }}>
          {`${successSnackBar?.message}`}
        </Alert>
      </Snackbar>
      <div className={classes.root}>
        <Tabs
          className={classes.tabs}
          value={value}
          onChange={handleChange}
          aria-label="Navigation entre les onglets de webinaires"
          orientation={isDesktop ? 'vertical' : 'horizontal'}
          variant={isDesktop ? 'standard' : 'scrollable'}
          scrollButtons="auto"
        >
          <Tab label="À venir" {...a11yProps(0)} />
          <Tab label="Replays" {...a11yProps(1)} />
          <Tab label="Mes webinaires" {...a11yProps(2)} />
        </Tabs>
        <div className={classes.tabPanelsWrap}>
          <TabPanel value={value} index={0} className={classes.tabPanelInner}>
            <UpcomingWebinaire
              userData={userData}
              setErrorSnackBar={setErrorSnackBar}
              setSuccessSnackBar={setSuccessSnackBar}
            />
          </TabPanel>
          <TabPanel value={value} index={1} className={classes.tabPanelInner}>
            <OldWebinaire setErrorSnackBar={setErrorSnackBar} />
          </TabPanel>
          <TabPanel value={value} index={2} className={classes.tabPanelInner}>
            <RegisteredWebinaire
              userData={userData}
              setErrorSnackBar={setErrorSnackBar}
              setSuccessSnackBar={setSuccessSnackBar}
            />
          </TabPanel>
        </div>
      </div>
    </>
  );
};

function mapState(state) {
  const { userData } = state.user;
  return {
    userData,
  };
}

const actionCreators = {
  changePageTitle: uiActions.changePageTitle,
};

export default connect(mapState, actionCreators)(Webinaire);
